import { Hexagon } from "lucide-react";

const ITEMS = [
  "$3 welcome bonus",
  "Windows · macOS · Android · iOS · Linux",
  "Cash out via PayPal or crypto",
  "Free forever — no card required",
  "Runs silently in the background",
  "No access to your personal data",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center whitespace-nowrap">
        <span className="px-8 font-display text-sm sm:text-base font-bold text-zinc-900">{item}</span>
        <Hexagon className="w-3.5 h-3.5 text-zinc-900/50 shrink-0" fill="currentColor" />
      </span>
    ))}
  </div>
);

const EditorialMarquee = () => (
  <section
    data-testid="editorial-marquee-container"
    aria-hidden
    className="overflow-hidden bg-amber-400 border-y border-amber-500/40 py-4 -rotate-1 scale-[1.02]"
  >
    <div className="flex animate-marquee w-max">
      <Row />
      <Row />
    </div>
  </section>
);

export default EditorialMarquee;
